var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-conv-list" },
    [
      _vm.conversationsLoading
        ? _c(
            "div",
            { staticClass: "viq-conv-list__loading" },
            _vm._l(4, function (i) {
              return _c("div", {
                key: i,
                staticClass: "viq-conv-list__skeleton",
              })
            }),
            0
          )
        : [
            _vm._l(_vm.flatConversations, function (conv) {
              return _c("ViqConversationItem", {
                key: conv.id,
                attrs: {
                  conversation: conv,
                  active:
                    _vm.activeConversation &&
                    _vm.activeConversation.id === conv.id,
                },
                on: {
                  select: function ($event) {
                    return _vm.selectConversation(conv)
                  },
                  rename: function ($event) {
                    return _vm.renameConversation(conv, $event)
                  },
                  delete: function ($event) {
                    return _vm.deleteConversation(conv.id)
                  },
                },
              })
            }),
            _vm._v(" "),
            !_vm.hasConversations && !_vm.conversationsLoading
              ? _c("div", { staticClass: "viq-conv-list__empty" }, [
                  _vm._v("\n      No conversations yet\n    "),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }